import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { hasPermission } from '../utils/hasPermission';

PermissionGuard.propTypes = {
  permission: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]).isRequired,
  children: PropTypes.node,
  fallback: PropTypes.node,
  redirectTo: PropTypes.string,
};

export default function PermissionGuard({ permission, children, fallback = null, redirectTo = '' }) {
  const { user } = useSelector((state) => state.auth);

  const allowed = hasPermission(user, permission);

  if (!allowed) {
    if (redirectTo) {
      return <Navigate to={redirectTo} replace />;
    }
    return fallback;
  }

  return <>{children}</>;
}
